import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Helper function for lazy loading with error handling
const lazyLoad = (importFunc: () => Promise<any>) => {
  return lazy(() => 
    importFunc().catch(error => {
      console.error('Failed to load component:', error);
      // Return a default component or re-throw the error
      return import('../pages/NotFound').then(module => ({ default: module.default }));
    })
  );
};

const HomePage = lazyLoad(() => import('../pages/home/page'));
const FunnelGeneratorPage = lazyLoad(() => import('../pages/funnel-generator/page'));
const MyFunnelsPage = lazyLoad(() => import('../pages/my-funnels/page'));
const FunnelAnalyticsPage = lazyLoad(() => import('../pages/funnel-analytics/page'));
const AwarenessCampaignPage = lazyLoad(() => import('../pages/awareness-campaign/page'));
const InterestCampaignPage = lazyLoad(() => import('../pages/interest-campaign/page'));
const ConsiderationCampaignPage = lazyLoad(() => import('../pages/consideration-campaign/page'));
const ConversionCampaignPage = lazyLoad(() => import('../pages/conversion-campaign/page'));
const RetentionCampaignPage = lazyLoad(() => import('../pages/retention-campaign/page'));
const LoginPage = lazyLoad(() => import('../pages/login/page'));
const SignupPage = lazyLoad(() => import('../pages/signup/page'));
const ProfilePage = lazyLoad(() => import('../pages/profile/page'));
const AdminPage = lazyLoad(() => import('../pages/admin/page'));
const PrivacyPolicyPage = lazyLoad(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazyLoad(() => import('../pages/terms-of-service/page'));
const NotFoundPage = lazyLoad(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/signup',
    element: <SignupPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/funnel-generator',
    element: <FunnelGeneratorPage />
  },
  {
    path: '/my-funnels',
    element: <MyFunnelsPage />
  },
  {
    path: '/funnel-analytics',
    element: <FunnelAnalyticsPage />
  },
  {
    path: '/awareness-campaign',
    element: <AwarenessCampaignPage />
  },
  {
    path: '/interest-campaign',
    element: <InterestCampaignPage />
  },
  {
    path: '/consideration-campaign',
    element: <ConsiderationCampaignPage />
  },
  {
    path: '/conversion-campaign',
    element: <ConversionCampaignPage />
  },
  {
    path: '/retention-campaign',
    element: <RetentionCampaignPage />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
